import React, { Component } from "react";
import Loader from "../../Shared/Loader/loader";
import { PageContainer, Content, Header } from "../../Drawer/PageContainer";
import Alice from "../../Display/Alice";
import { Splitter } from "@progress/kendo-react-layout";
import LookupSidebar from "./LookupSidebar";
import DateTimeTypeField from "../Fields/DateTimeTypeField";
import AttributeTypes from "../AttributeTypes";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import Scrollable from "../../Shared/Edit/Scrollable";
import RemoveDialog from "../../Shared/Remove/RemoveDialog";
import NumberTypeField from "../Fields/NumberTypeField";
import { PicklistOptionsField } from "../Fields/PicklistStringFields";
import SaveDialog from "../../Shared/Remove/SaveDialog";
import ErrorMessage from "../../Shared/Error/ErrorMessage";
import ServerError from "../../Shared/Error/ServerError";
import AttributeTypePopup from "../AttributeTypePopup";
import InnerLoader from "../../Shared/Loader/InnerLoader";
import { withTranslation } from "react-i18next";
import { StateFeildOptionsField } from "../Fields/StateFields";
import { createAttributeTemplate, deleteAttributeTemplate, getAttributeTemplates } from "../../../API/AttributeTemplate/AttributeTemplate";
import { uuidv4 } from "../Fields/TreeDropdownHelper";

class Lookup extends Component {
    createLookupButton = React.createRef();
    createAndNewLookupButton = React.createRef();
    Icons = AttributeTypes.Icons;

    attributeTypeRender = (li, itemProps) => {
        const itemChildren = (
            <div className="items-center w-100 d-flex">
                <div style={{ width: "30px" }}>
                    <i className={itemProps.dataItem.icon}></i>
                </div>
                {itemProps.dataItem.text}
            </div>
        );
        return React.cloneElement(li, { tabIndex: 0 }, itemChildren);
    };

    constructor(props) {
        super(props);
        this.DataTypes = AttributeTypes.getTranslatedTypes(props.t);
        this.state = {
            loading: true,
            DataTypes: this.DataTypes,
            panes: [
                { collapsible: false },
                { size: "475px", min: "475px", collapsible: false },
            ],
            selectedAttribute: {},
            nextAttributeId: "",
            data: [],
            showCreateAttributeTemplate: false,
            showServerError: false,
            nameError: {
                isValid: true,
                message: ""
            },
            numberType: "integer",
            lookupName: "",
            lookupType: this.DataTypes[0],
            visible: false,
            picklist: "",
            isPicklistProper: true,
            dateTimeType: "date",
            description: "",
            showInIframe: this.props.showInIframe,
            deletingAttributeTemplate: false,
            creatingAttributeTemplate: false,
            statefieldError: {
                isValid: true,
                message: "",
            },
            statefield: []
        };
        this.LookupSidebar = React.createRef();
    }

    render() {
        if (this.state.showServerError) return <ServerError />
        const { t } = this.props;
        if (this.state.loading) {
            return <Loader />;
        }

        return (
            <PageContainer>
                <Header
                    header={this.props.showInIframe ? "" : t("header.title")}
                    showAction={true}
                    actionText={t("header.buttons.add_property_button")}
                    actionClicked={this.toggleCreateAttributeDialog}
                ></Header>
                <Content>
                    {this.state.data.length === 0 && (
                        <Alice
                            mode="new"
                            header={t("no_records.title")}
                        >
                            {t("no_records.message1")}
                            <br /><br />
                            {t("no_records.message2")}
                        </Alice>
                    )}
                    {this.state.showCreateAttributeTemplate === true && (
                        <Dialog
                            title={t("title", { ns: "property_template/create_dialog" })}
                            onClose={this.toggleDialog}
                        >
                            <form className="d-flex flex-column h-100" onSubmit={this.add}>
                                <div className="mb-2">
                                    <div className="form-label d-inline-block name-text" required>
                                        {t("fields.name", { ns: "property_template/create_dialog" })}
                                    </div>
                                    <ErrorMessage
                                        valid={this.state.nameError.isValid}
                                        error={this.state.nameError.message}
                                    />
                                    <input
                                        onChange={this.handleName}
                                        className="form-control name-text"
                                        autoFocus={true}
                                        type="text"
                                        name="name"
                                        ref={(rf) => (this.attributeTemplateName = rf)}
                                        value={this.state.lookupName}
                                    />
                                </div>
                                <div className="mb-2">
                                    <div className="d-flex justify-content-between">
                                        <div className="form-label">
                                            {t("fields.type", { ns: "property_template/create_dialog" })}
                                        </div>
                                        <span className="form-label text-link fw-bold cursor-pointer" onClick={this.toggleAttributeTypesPopup}>
                                            {t("fields.type_link", { ns: "property_template/create_dialog" })}
                                        </span>
                                    </div>
                                    <ComboBox
                                        className="form-control-custom"
                                        data={this.getDataTypes()}
                                        textField="text"
                                        itemRender={this.attributeTypeRender}
                                        onFilterChange={this.handleType}
                                        filterable={true}
                                        onChange={this.set_value}
                                        suggest={true}
                                        allowCustom={false}
                                        valid={this.state.lookupType !== null}
                                        value={this.state.lookupType}
                                    />
                                </div>

                                <div className="mb-2">
                                    {this.state.lookupType.value ===
                                        "DateTime" && (
                                            <DateTimeTypeField
                                                value={this.state.dateTimeType}
                                                onChange={this.handleDateTimeType}
                                            />
                                        )}
                                    {this.state.lookupType.value ===
                                        "Number" && (
                                            <NumberTypeField
                                                value={this.state.numberType}
                                                onChange={this.handleNumberType}
                                            />
                                        )}
                                </div>

                                <div className="mb-2">
                                    {this.state.lookupType.value === "State Field" && (
                                        <div>
                                            <div className="form-label">
                                                <span required>{t("fields.state_field", { ns: "property_template/create_dialog" })}</span>
                                                {this.state.statefieldError.isValid === false && <span className="mx-1 text-danger">{this.state.statefieldError.message}</span>}
                                            </div>
                                            <div className="drop-container">
                                                <StateFeildOptionsField
                                                    showLanguageTranslation={false}
                                                    onChange={this.handleStateFieldChange}
                                                    value={this.state.statefield}
                                                    onErr={(e) => {
                                                        let { statefieldError } = this.state;
                                                        statefieldError.isValid = e.length < 0;
                                                        this.setState({
                                                            statefieldError: statefieldError,
                                                        });
                                                    }}
                                                    autoFocus={true}
                                                    showColorPicker={false}
                                                    TooltipPosition={'left'}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="mb-2">
                                    {this.state.lookupType.value ===
                                        "Picklist String" ? (
                                        <>
                                            <div className="form-label">
                                                <span required>
                                                    {t("fields.dropdown_values", { ns: "property_template/create_dialog" })}
                                                </span> &nbsp;
                                                {!this.state.isPicklistProper && (
                                                    <span className="mx-1 error">
                                                        {t("errors.dropdown_values_duplicate", { ns: "property_template/create_dialog" })}
                                                    </span>
                                                )}
                                            </div>
                                            <PicklistOptionsField
                                                addDropdownButtonText={t("buttons.add_dropdown_value", { ns: "property_template/create_dialog" })}
                                                onChange={
                                                    this.handleDropdownChange
                                                }
                                                value={this.state.picklist}
                                                onErr={(e) => {
                                                    this.setState({
                                                        isPicklistProper:
                                                            e.length < 0,
                                                    });
                                                }}
                                                autoFocus={true}
                                            />
                                        </>
                                    ) : null}
                                </div>

                                <div className="mb-2">
                                    <div className="form-label">
                                        {t("fields.description", { ns: "property_template/create_dialog" })}
                                    </div>
                                    <textarea
                                        value={this.state.description}
                                        onChange={this.setDescription}
                                        className="form-control"
                                        style={{ height: "50px" }}
                                    ></textarea>
                                </div>
                                <DialogActionsBar layout="end">
                                    {this.state.creatingAttributeTemplate &&
                                        <small className="mt-2">
                                            <div className="d-inline-block">
                                                <InnerLoader borderColor="green" />
                                                <span className="me-4 text-danger"></span>
                                            </div>
                                        </small>
                                    }
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={this.toggleDialog}
                                    >
                                        {t("buttons.cancel", { ns: "property_template/create_dialog" })}
                                    </button>
                                    <button
                                        type={this.state.lookupType.value === "Picklist String" ? "button" : "submit"}
                                        ref={this.createAndNewLookupButton}
                                        name="CreateNew"
                                        className="btn btn-primary"
                                        disabled={this.shouldCreateBeDisabled()}
                                        onClick={this.addandNew}
                                    >
                                        {t("buttons.create_and_new", { ns: "property_template/create_dialog" })}
                                    </button>
                                    <button
                                        type={this.state.lookupType.value === "Picklist String" ? "button" : "submit"}
                                        onClick={this.add}
                                        ref={this.createLookupButton}
                                        name="Create"
                                        className="btn btn-primary"
                                        disabled={this.shouldCreateBeDisabled()}
                                    >
                                        {t("buttons.create", { ns: "property_template/create_dialog" })}
                                    </button>
                                </DialogActionsBar>
                            </form>
                        </Dialog>
                    )}

                    {
                        this.state.showAttributeTypePopup &&
                        <AttributeTypePopup
                            excludedTypes={["Shared Lookup", "Mirror"]}
                            data={this.state.data}
                            onClose={this.toggleAttributeTypesPopup}
                            onSelect={this.selectAttributeTypeAndTogglePopup} />
                    }

                    {this.state.data.length !== 0 && (
                        <>
                            {this.state.visible && (
                                <SaveDialog
                                    toggleSaveDialog={this.Discard}
                                    onSave={this.Save}
                                    message={t("unsaved_dialog.warning", { ns: "property_template/common" })}
                                    Title={t("unsaved_dialog.title", { ns: "property_template/common" })}
                                    SaveButtonText={t("unsaved_dialog.buttons.save_and_continue", { ns: "property_template/common" })}
                                    cancelButtonText={t("unsaved_dialog.buttons.cancel", { ns: "property_template/common" })}
                                    onCancel={this.Discard}
                                />
                            )}
                            {this.state.DeletePopup && (
                                <RemoveDialog
                                    toggleDeleteDialog={this.toggleDeleteDialog}
                                    showLoader={this.state.deletingAttributeTemplate}
                                    onDelete={this.DeleteConfirmation}
                                    deleteButtonText={t("delete_dialog.buttons.delete", { ns: "property_template/common" })}
                                    cancelButtonText={t("delete_dialog.buttons.cancel", { ns: "property_template/common" })}
                                    message={t("delete_dialog.warning", { ns: "property_template/common" })}
                                    Title={t("delete_dialog.title", { ns: "property_template/common" })}
                                />
                            )}
                            <Splitter
                                panes={this.state.panes}
                                onChange={this.onSplitterSizeChange}
                            >
                                <div className={`py-3 h-100 ${this.props.showInIframe ? "checkRuntimeUser" : ""}`}>
                                    <Scrollable>
                                        <Grid
                                            data={this.state.data.map((item) => ({
                                                ...item,
                                                selected: item._id === this.state.selectedAttribute._id,
                                            }))}
                                            onRowClick={this.rowClick}
                                            selectedField="selected"
                                        >
                                            <Column title="#" width={60} cell={(props) =>
                                                <td>
                                                    <span className="ps-2">{props.dataItem.indexId}</span>
                                                </td>
                                            } />
                                            <Column field="LookupName" title={t("grid.header.name")} />
                                            <Column field="typeText" title={t("grid.header.type")}
                                                cell={(props) => (
                                                    <td>
                                                        <i style={{ width: 15 }} className={`${this.Icons[props.dataItem.lookupType]} pe-1`}></i>
                                                        {t("attribute_type_label." + props.dataItem.lookupType.toLowerCase().split(" ").join("_"), { ns: "attribute/attribute_type" })}
                                                    </td>
                                                )}
                                            />
                                            <Column field="description" title={t("grid.header.description")} />
                                        </Grid>
                                    </Scrollable>
                                </div>
                                <div className="h-100">
                                    {this.state.data.length > 0 && (
                                        <LookupSidebar
                                            LookupData={this.state.data}
                                            selectedAttribute={this.state.selectedAttribute}
                                            updateAttribute={this.onSideAttributeChange}
                                            Delete={this.Delete}
                                            ref={this.LookupSidebar}
                                            showInIframe={this.state.showInIframe}
                                        />
                                    )}
                                </div>
                            </Splitter>
                        </>
                    )}
                </Content>
            </PageContainer >
        );
    }

    onSplitterSizeChange = (e) => {
        this.setState({ panes: e.newState });
    };

    toggleAttributeTypesPopup = () => {
        this.setState({ showAttributeTypePopup: !this.state.showAttributeTypePopup });
    }

    selectAttributeTypeAndTogglePopup = (value) => {
        this.set_value({ target: { value } });
        this.toggleAttributeTypesPopup();
    }

    getDataTypes = () => {
        return this.state.DataTypes.filter((item) => item.value !== "Shared Lookup" && item.value !== "Mirror");
    }

    componentDidMount = async () => {
        try {
            const attributes = await this.getAttributeTemplate()
            this.setState({
                data: attributes,
                loading: false
            }, () => {
                if (attributes.length > 0) {
                    if (this.props.selectedAttributeTemplate) {
                        let attribute = this.state.data.find((item) => item.sysName === this.props.selectedAttributeTemplate)
                        this.rowClick(attribute._id)
                    } else {
                        this.rowClick(attributes[0]._id)
                    }
                }
            })
        } catch (error) {
            console.error(error)
            this.setState({
                showServerError: true
            })
        }
    }

    getAttributeTemplate = async () => {
        let result = await getAttributeTemplates(this.props.organization._id);
        const sortedAttributes = result.slice().sort((a, b) => a.LookupName.localeCompare(b.LookupName));
        for (let i = 0; i < sortedAttributes.length; i++) {
            sortedAttributes[i].indexId = i + 1;
            sortedAttributes[i].typeText = this.DataTypes.find((type) => type.value === sortedAttributes[i].lookupType).text;
        }
        return sortedAttributes
    };

    rowClick = (value) => {
        var _id = "";

        if (value["dataItem"]) {
            _id = value.dataItem._id;
        } else {
            _id = value;
        }

        let attributePropertiesAreSame = this.LookupSidebar.current.getDisabled();
        let isAttributeDeleted = this.state.data.find((attribute) => attribute._id === this.LookupSidebar.current.defaultData._id) === undefined;

        if (attributePropertiesAreSame || isAttributeDeleted) {
            let nextAttribute = this.state.data.find((attribute) => attribute._id === _id);
            this.setState({
                visible: false,
                nextAttributeId: "",
                selectedAttribute: nextAttribute
            });
        } else {
            this.setState({
                visible: true,
                nextAttributeId: _id
            });
        }
    };

    //handle

    toggleCreateAttributeDialog = () => {
        this.setState({
            showCreateAttributeTemplate: !this.state.showCreateAttributeTemplate,
            showError: false,
            error: "",
            lookupName: "",
            picklist: "",
            description: "",
            lookupType: this.DataTypes[0],
            nameError: {
                isValid: true,
                message: ""
            },
            isPicklistProper: true,
            dateTimeType: "date",
        });
    };

    toggleDialog = (e) => {
        this.setState({
            showCreateAttributeTemplate: false,
            lookupName: "",
            picklist: "",
            description: "",
            lookupType: this.DataTypes[0],
            nameError: {
                isValid: true,
                message: ""
            },
            dateTimeType: "date",
        });
    };

    handleName = (e) => {
        let { nameError } = this.state
        let { value } = e.target
        const { t } = this.props;
        const nameIsReserved = value.toLowerCase().replace(/[^a-zA-Z0-9]/g, "").trim() === "id"
        const nameIsBlank = value.trim() === ""
        const nameInUse = this.state.data.findIndex((item) => item.LookupName.trim().toLowerCase() === e.target.value.trim().toLowerCase()) > -1;
        const nameContainsSys = /^\[SYS\]/i.test(value.trim());
        const nameStartWithNumber = value.trim().match(/^\d/)
        const hasSpecialCharacters = /[\\"'\/]/.test(value.trim());
        if (nameIsBlank) {
            nameError.isValid = false
            nameError.message = t("errors.name_required", { ns: "property_template/create_dialog" })
        } else if (nameStartWithNumber) {
            nameError.isValid = false
            nameError.message = t("errors.name_starts_with_number", { ns: "property_template/create_dialog" })
        } else if (nameInUse) {
            nameError.isValid = false
            nameError.message = t("errors.name_in_use", { ns: "property_template/create_dialog" })
        } else if (nameContainsSys) {
            nameError.isValid = false
            nameError.message = t("errors.name_contains_sys", { ns: "property_template/create_dialog" });
        } else if (hasSpecialCharacters) {
            nameError.isValid = false
            nameError.message = t("errors.name_contain_specical_character", { ns: "property_template/create_dialog" });
        } else if (nameIsReserved) {
            nameError.isValid = false
            nameError.message = t("errors.name_is_reserved", { ns: "property_template/create_dialog" });
        } else {
            nameError.isValid = true
            nameError.message = "";
        }

        this.setState({
            lookupName: e.target.value,
            nameError: nameError
        });
    };

    handleType = (event) => {
        let { DataTypes } = this;

        if (event.filter.value.trim() !== "") {
            DataTypes = DataTypes.filter((x) =>
                x.text
                    .toLowerCase()
                    .startsWith(event.filter.value.toLowerCase())
            );
        }

        this.setState({
            DataTypes: DataTypes,
        });
    };

    handleStateFieldChange = (data) => {
        let statefieldError = this.CheckStateFieldisProper(data);
        this.setState({
            statefield: data,
            statefieldError: statefieldError,
        });
    };

    CheckStateFieldisProper = (data) => {
        const { t } = this.props;
        const statefieldValues = data
            .filter((option) => option.name.trim() !== "")
            .map((option) => option.name.trim());

        const statefieldValuesMap = {};
        let statefieldError = {
            isValid: true,
            message: "",
        };

        if (statefieldValues.length === 0) {
            statefieldError.isValid = false
            return statefieldError;
        }
        for (const value of statefieldValues) {
            statefieldValuesMap[value] = statefieldValuesMap[value] ? ++statefieldValuesMap[value] : 1;
            if (statefieldValuesMap[value] > 1) {
                statefieldError.isValid = false;
                statefieldError.message = t("errors.duplicate_state_field", { ns: "property_template/create_dialog" });
                break;
            }
        }
        return statefieldError;
    };

    set_value = (e) => {
        if (e.target.value === null) {
            this.setState({ lookupType: this.DataTypes[0] });
        } else {
            this.setState({ lookupType: e.target.value });
        }
        if (e.target.value !== "Picklist String") {
            this.setState({
                isPicklistProper: true,
                picklist: "",
            });
        }
        if (e.target.value !== "State Field") {
            this.setState({
                statefield: [],
                statefieldError: {
                    isValid: true,
                    message: "",
                }
            })
        }
    };

    handleDropdownChange = (e) => {
        let isPicklistProper = this.isPicklistProper(e.target.value);
        this.setState({
            picklist: e.target.value,
            isPicklistProper: isPicklistProper,
        });
    };

    isPicklistProper = (data) => {
        const picklistValues = data
            .split("ɖ")
            .filter((option) => option.trim() !== "")
            .map((option) => option.trim());
        const picklistValuesMap = {};
        let isPicklistValid = true;

        // if (picklistValues.length === 0) return false;

        for (const value of picklistValues) {
            picklistValuesMap[value] = picklistValuesMap[value]
                ? ++picklistValuesMap[value]
                : 1;
            if (picklistValuesMap[value] > 1) {
                isPicklistValid = false;
                break;
            }
        }
        return isPicklistValid;
    };

    handleDateTimeType = (e) => {
        this.setState({ dateTimeType: e.value });
    };

    handleNumberType = (e) => {
        this.setState({
            numberType: e.value,
        });
    };

    shouldCreateBeDisabled = () => {
        if (this.state.lookupName.trim() === "") {
            return true;
        }
        if (!this.state.nameError.isValid) {
            return true;
        }

        if (this.state.lookupType.value === "Picklist String") {
            if (!this.state.isPicklistProper) {
                return true;
            }

            if (this.state.picklist.length === 0) {
                return true;
            }
        }

        if (this.state.lookupType.value === "State Field") {
            if (!this.state.statefieldError.isValid) {
                return true;
            }

            if (this.state.statefield !== undefined && this.state.statefield.length === 0) {
                return true;
            }
        }

        return false;
    };

    setDescription = (e) => {
        this.setState({ description: e.target.value });
    };

    //Crud

    add = async (e, keepFormVisible) => {
        const { createLookupButton, createAndNewLookupButton } = this;
        createLookupButton.current.disabled = true;
        createAndNewLookupButton.current.disabled = true;
        this.setState({ creatingAttributeTemplate: true })
        e.preventDefault();
        var value = this.state.lookupName
            .trim()
            .replace(/\s\s+/g, " ")
            .toLowerCase();

        let sysName = this.state.lookupName
            .replace(/[^a-zA-Z0-9]/g, "")
            .toLowerCase();

        if (sysName.trim() === "") {
            sysName = "attributeTemplate";
        }

        let pattern = "^" + sysName + "(\\d+)?$";
        let regex = new RegExp(pattern, "g");

        let similarNames = this.state.data
            .filter((x) => {
                if (x.sysName && x.sysName.match(regex)) {
                    return x;
                }
            })
            .sort((a, b) => a.sysName > b.sysName);

        if (similarNames.length > 0) {
            sysName = similarNames[similarNames.length - 1].sysName + "1";
        }

        let order =
            this.state.data.length > 0
                ? parseInt(
                    this.state.data[this.state.data.length - 1]["order"]
                ) + 10000000000
                : 0;

        let propertiesData = {
            LookupName: this.state.lookupName.trim(),
            sysName: sysName,
            label: this.state.lookupName.trim(),
            lookupType: this.state.lookupType.value,
            typeText: this.DataTypes.find(
                (type) => type.value === this.state.lookupType.value
            ).text,
            description: this.state.description,
            order: order + 10000000000,
        };

        if (propertiesData.lookupType === "String") {
            propertiesData.min = "1";
            propertiesData.max = "128";
            propertiesData.pattern = "";
        }

        if (propertiesData.lookupType === "Picklist String") {

            // clear empty item from picklist - ali
            let values = this.state.picklist.split('ɖ')
            values = values.filter(o => o.length > 0)
            values = values.join('ɖ');

            propertiesData.picklist = values;
            propertiesData.multiSelect = false;
        }

        if (propertiesData.lookupType === "Number") {
            propertiesData.numberType = this.state.numberType;
            propertiesData.unit = "none";
            propertiesData.min = "";
            propertiesData.max = "";
            propertiesData.useThousandSeparator = false;
            propertiesData.unitSide = "Right";
            propertiesData.decimalPlace = "2";
        }

        if (propertiesData.lookupType === "User Identity") {
            propertiesData.showProfilePicture = true;
            propertiesData.useDisplayName = false;
            propertiesData.multiSelect = false;
        }

        if (propertiesData.lookupType === "DateTime") {
            propertiesData.dateTimeType = this.state.dateTimeType;
            if (this.state.dateTimeType === "date") {
                propertiesData.defaultDate = "Today_+_0_Days";
                propertiesData.setDefaultDate = true;
                propertiesData.defaultTime = "10:00 AM";
            } else if (this.state.dateTimeType === "time") {
                propertiesData.defaultDate = "Today_+_0_Days";
                propertiesData.setDefaultDate = true;
                propertiesData.defaultTime = "10:00 AM";
                propertiesData.interval = "15";
                propertiesData.minTime = "";
                propertiesData.maxTime = "";
            } else {
                propertiesData.defaultDate = "Today_+_0_Days";
                propertiesData.setDefaultDate = true;
                propertiesData.defaultTime = "10:00 AM";
                propertiesData.interval = "15";
                propertiesData.minTime = "";
                propertiesData.maxTime = "";
            }
        }

        if (propertiesData.lookupType === "State Field") {
            let values = this.state.statefield
            values = values.filter(o => o.name.trim().length > 0)
            for (let i = 0; i < values.length; i++) {
                values[i]._id = uuidv4()
                values[i].name = values[i].name.trim()
                values[i].order = parseInt((i + 1) * 10000000000);
            }
            propertiesData['statefield'] = values
        }
        await this.postAdd(propertiesData, keepFormVisible);
    };

    postAdd = async (propertiesData, keepFormVisible) => {
        let AttributeTemplate = await createAttributeTemplate(this.props.organization._id, propertiesData);

        let { data } = this.state;
        AttributeTemplate.indexId = this.state.data.length + 1;
        data.push(AttributeTemplate);
        data = data.slice().sort((a, b) => a.LookupName.localeCompare(b.LookupName));
        for (let i = 0; i < data.length; i++) {
            data[i].indexId = i + 1;
            data[i].typeText = this.DataTypes.find(
                (type) => type.value === data[i].lookupType
            ).text;
        }
        this.setState({
            data: data,
            showCreateAttributeTemplate: keepFormVisible,
            lookupName: "",
            picklist: "",
            description: "",
            lookupType: this.DataTypes[0],
            nameError: {
                isValid: true,
                message: ""
            },
            dateTimeType: "date",
            numberType: "integer",
            statefield: [],
            statefieldError: {
                isValid: true,
                message: "",
            },
            creatingAttributeTemplate: false,
        }, () => {
            if (data.length > 1) {
                this.rowClick(AttributeTemplate._id);
            } else {
                this.setState({
                    selectedAttribute: AttributeTemplate
                })
            }
        });
    };

    addandNew = (e) => {
        this.add(e, true);
        this.attributeTemplateName.focus();
    };

    Delete = (e) => {
        const _id = e.currentTarget === undefined ? e : e.currentTarget.value;
        let element = this.state.data.find((x) => x._id === _id);
        this.setState({
            DeletePopup: true,
            toDeleteId: element._id,
        });
    };

    toggleDeleteDialog = (e) => {
        this.setState({
            DeletePopup: false,
        });
    };

    DeleteConfirmation = async (e) => {
        e.target.disabled = true;
        const _id = this.state.toDeleteId;
        this.setState({
            deletingAttributeTemplate: true,
        })
        let element = this.state.data.find((x) => x._id === _id);
        await this.remove(element);
        this.setState({
            deletingAttributeTemplate: false,
            DeletePopup: !this.state.DeletePopup,
            toDeleteId: "",
        });
    };

    remove = async (dataItem) => {
        await deleteAttributeTemplate(dataItem._id);
        const data = [...this.state.data];
        let index = data.findIndex((p) => p === dataItem || (dataItem._id && p._id === dataItem._id));
        let toGet = 0;
        if (index >= 0) {
            data.splice(index, 1);
        }

        for (let i = 0; i < data.length; i++) {
            data[i].indexId = i + 1;
        }
        this.setState({ data });

        if (index === 0) {
            if (data.length > 0) {
                this.rowClick(data[toGet]._id);
            } else {
                this.setState({ selectedAttribute: {}, showCreateAttributeTemplate: false });
            }
        } else {
            toGet = index - 1;
            if (this.state.selectedAttribute._id === dataItem._id) {
                this.rowClick(data[toGet]._id);
            }
        }
    };

    Save = () => {
        this.LookupSidebar.current.Save();
    };

    Discard = () => {
        var { data } = this.state;
        this.LookupSidebar.current.cancel();
        var nextAttribute = data.find((item) => item._id === this.state.nextAttributeId);
        this.setState({
            visible: false,
            selectedAttribute: nextAttribute,
            nextAttributeId: ""
        })
    };

    onSideAttributeChange = (_id, sidedata) => {
        var { data, selectedAttribute } = this.state;
        var index = data.findIndex((item) => item._id === _id)
        var element = data.find((item) => item._id === _id);
        sidedata.indexId = element.indexId;
        data[index] = sidedata;

        const sortedAttributes = data.slice().sort((a, b) => a.LookupName.localeCompare(b.LookupName));

        for (let i = 0; i < sortedAttributes.length; i++) {
            sortedAttributes[i].indexId = i + 1;
            sortedAttributes[i].typeText = this.DataTypes.find((type) => type.value === sortedAttributes[i].lookupType).text
        }

        if (this.state.nextAttributeId !== "") {
            var nextAttribute = data.find((item) => item._id === this.state.nextAttributeId);
            selectedAttribute = { ...nextAttribute }
        }

        this.setState({
            data: sortedAttributes,
            visible: false,
            selectedAttribute,
            nextAttributeId: ""
        })
    };
}

export default withTranslation([
    "property_template/common",
    "property_template/create_dialog",
    "attribute/attribute_type"
], {
    withRef: true
})(Lookup);
